import useGetRejectReasons from './useGetRejectReasons'

export default useGetRejectReasons
